import React from "react";
import ADNavbar from "../components/ADNavbar";
import SiteFooter from "../components/SiteFooter";
import { assets, siteConfig } from "../data/mock";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const Section = ({ title, children }) => (
  <div className="mb-12">
    <p className="text-xs tracking-[0.2em] uppercase text-gray-400 mb-4 border-b border-gray-100 pb-2">{title}</p>
    {children}
  </div>
);

const AssetsPage = () => (
  <>
    <ADNavbar />
    <section className="pt-28 pb-20 px-6">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-1 text-xs text-gray-400 hover:text-gray-600 transition-colors mb-10">
          <ArrowLeft size={12} /> Back
        </Link>

        <div className="mb-10">
          <p className="text-[10px] tracking-[0.3em] uppercase text-gray-400 border border-gray-200 inline-block px-2 py-0.5 mb-4">Private</p>
          <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>Assets</h1>
          <p className="text-sm text-gray-400 mt-2">Internal reference page for brand assets and content.</p>
        </div>

        <Section title="Headshots">
          <div className="space-y-3">
            {assets.headshots.map((h, i) => (
              <div key={i} className="flex items-center justify-between py-2 border-b border-gray-50">
                <span className="text-sm text-gray-700">{h.label}</span>
                <span className="text-xs text-gray-300">{h.url}</span>
              </div>
            ))}
          </div>
        </Section>

        <Section title="Logos">
          <div className="space-y-3">
            {assets.logos.map((l, i) => (
              <div key={i} className="flex items-center justify-between py-2 border-b border-gray-50">
                <span className="text-sm text-gray-700">{l.label}</span>
                <span className="text-xs text-gray-300">{l.url}</span>
              </div>
            ))}
          </div>
        </Section>

        <Section title="Book Descriptions">
          <div className="space-y-4">
            {assets.bookDescriptions.map((b, i) => (
              <div key={i} className="py-3 border-b border-gray-50">
                <p className="text-sm font-medium text-gray-700 mb-1">{b.title}</p>
                <p className="text-xs text-gray-300">{b.fullDescription}</p>
              </div>
            ))}
          </div>
        </Section>

        <Section title="External Links">
          <div className="space-y-3">
            {assets.externalLinks.map((l, i) => (
              <div key={i} className="flex items-center justify-between py-2 border-b border-gray-50">
                <span className="text-sm text-gray-700">{l.label}</span>
                <span className="text-xs text-gray-300">{l.url}</span>
              </div>
            ))}
          </div>
        </Section>
      </div>
    </section>

    <SiteFooter />
  </>
);

export default AssetsPage;
